import { render } from "./Or_variation.vue?vue&type=template&id=6ab715b7&scoped=true&ts=true"
import script from "./Or_variation.vue?vue&type=script&lang=ts"
export * from "./Or_variation.vue?vue&type=script&lang=ts"

import "./Or_variation.vue?vue&type=style&index=0&id=6ab715b7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab715b7"]])

export default __exports__